module.exports = __webpack_public_path__ + "static/media/stop-hand-primary.63189ec3.svg";